<template>
  <div class="main-user">
    <el-row>
      <el-form
        :inline="true"
        :model="searchForm"
        class="demo-form-inline search-form"
        size="small"
      >
        <el-form-item style="width: 80px;">
          <el-input
            v-model="searchForm.realName"
            placeholder="姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item style="width: 180px;">
          <el-input
            v-model="searchForm.idNumber"
            placeholder="证件号码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item style="width: 165px;">
          <el-select
              v-model="searchForm.tags"
              filterable
              remote
              :remote-method="onGetTagsLike"
              :loading="loadingTagsLike"
              clearable
              placeholder="输入关键词选择标签"
          >
            <el-option
                v-for="item in tagsLikeList"
                :key="item"
                :label="item"
                :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="width: 220px;">
          <el-date-picker
            v-model="registerDate"
            clearable
            type="daterange"
            start-placeholder="注册开始日期"
            end-placeholder="注册结束日期"
            value-format="yyyy-MM-dd"
            style="width: 220px;"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearchUser" icon="el-icon-search"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item
            v-permission="['user:userInfo:addUserInfo']"
        >
          <el-button type="primary" @click="onCreateUser" icon="el-icon-plus"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>
    <el-row class="button">
      <el-button
          v-permission="['user:userInfo:importUserInfo']"
          size="small" @click="importUserInfoVisible = true"
      >导入个人信息</el-button
      >
      <el-button
          v-permission="['user:userInfo:importIdPhoto']"
          size="small" @click="importPhotoVisible = true"
        >导入证件照</el-button
      >
      <el-button size="small" @click="importTrainingFileVisible = true" v-permission="['user:userInfo:importTrainingFile']"
      >导入培训证明</el-button
      >
      <el-button
          v-permission="['user:userInfo:exportUserInfo']"
          size="small" @click="exportUserInfo"
                 :disabled="!tableData.length>0"
                 v-if="getUserImportType !== 'special'">导出个人信息</el-button>
      <el-button
        v-permission="['user:userInfo:bindExam']"
        size="small"
        @click="bindUserExamVisible = true"
        :disabled="!bindForm.userIds || bindForm.userIds.length <= 0"
        >绑定考场</el-button>
      <el-button
          size="small" v-permission="['user:userInfo:addTags']"
          @click="addTagsVisible = true"
          :disabled="!bindForm.userIds || bindForm.userIds.length <= 0"
        >添加标签</el-button
      >
    </el-row>
    <el-card shadow="never" class="card-fix-height scrollable">
      <el-table
        :data="tableData"
        v-loading="loading"
        row-key="id"
        stripe
        @selection-change="handleSelectionChange"
        style="width: 100%;overflow-y: auto"
        :height="tableHeight"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column
          prop="realName"
          label="姓名"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="idNumber"
          label="证件号码"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="mphone"
          label="手机号"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="agentName"
          label="机构"
          align="center"

          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="createDate"
          label="注册时间"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="status"
          :formatter="statusFormatter"
          label="审核状态"
          width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="tags" label="标签" width="120" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-tooltip
              v-permission="['user:userInfo:viewBindExam']"
              class="item"
              effect="dark"
              content="查看绑定考场"
              placement="top-start"
              v-if="scope.row.bindStatus == 1"
            >
              <el-button
                icon="el-icon-view"
                type="primary"
                size="mini"
                circle
                @click="viewExam(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              v-permission="['user:userInfo:editUserInfo']"
              class="item"
              effect="dark"
              content="编辑"
              placement="top-start"
            >
              <el-button
                icon="el-icon-edit-outline"
                circle
                type="primary"
                size="mini"
                @click="
                  jumpPage({
                    path: '/userInfo/editUser',
                    query: { id: scope.row.userId }
                  })
                "
              ></el-button>
            </el-tooltip>
            <el-tooltip
              v-permission="['user:userInfo:viewResume']"
              class="item"
              effect="dark"
              content="查看简历"
              placement="top-start"
            >
              <el-button
                icon="el-icon-user-solid"
                type="primary"
                size="mini"
                circle
                @click="showUserResume(scope.row)"
              ></el-button>
              >
            </el-tooltip>
            <el-tooltip
              v-permission="['user:userInfo:deleteUserInfo']"
              content="删除"
              placement="top"
              v-if="agentId == scope.row.createBy"
            >
              <el-button
                icon="el-icon-delete"
                type="primary"
                size="mini"
                circle
                @click="delUser(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-pagination
      class="footer"
      background
      :layout="tableLayout"
      :total="tableTotal"
      :current-page="currentPage"
      :page-size.sync="pageSize"
      @current-change="onCurrentPageChange"
      @size-change="handleSizeChange"
      :page-sizes="[20, 100, 500]"
      align="center"
    >
    </el-pagination>

    <el-dialog
      title="导入证件照"
      :visible.sync="importPhotoVisible"
      width="700px"
    >
      <el-form label-width="80px">
        <el-form-item label="导入说明">
          <div style="color:red;">1.必须上传ZIP格式压缩包，且不含文件夹</div>
          <div style="color:red;">2.以证件号码命名的1寸免冠照片（格式为jpg或者png，建议626*413像素）</div>
          <div style="color:red;">3.每张图片大小不超过128K，一次最多上传2000张</div>
          <div>
            附：<a
              href="/template/两寸照片生成器.zip"
              target="_blank"
              style="color: blue; text-decoration: underline"
              >两寸照片生成器</a
            >
          </div>
        </el-form-item>
        <el-form-item>
          <el-upload
            ref="fileUploader"
            class="avatar-uploader"
            :action="apiConfig.userInfo.api.importIdPhoto.url.import"
            :headers="headers"
            :multiple="false"
            :limit="1"
            :fileList="fileList"
            accept="application/x-zip-compressed"
            :on-progress="handleProgress"
            :on-error="handleError"
            :on-success="uploaded"
            :before-upload="beforeAvatarUpload"
          >
            <el-button slot="trigger" size="small" type="primary">
              选取文件</el-button
            >
          </el-upload>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
        title="导入培训证明"
        :visible.sync="importTrainingFileVisible"
        width="650px"
    >
      <el-form label-width="80px">
        <el-form-item label="导入说明">
          <div style="color:red;">1.必须上传ZIP格式压缩包，且不含文件夹</div>
          <div style="color:red;">2.以证书编号命名的图片（格式为jpg或者png），例如：RKX22WM283001392.jpg</div>
          <div style="color:red;">3.每张图片大小不超过512K，一次最多上传2000张</div>
        </el-form-item>
        <el-form-item>
          <el-upload
              ref="fileUploader"
              class="avatar-uploader"
              :action="apiConfig.userInfo.api.importTrainingFile.url.import"
              :headers="headers"
              :multiple="false"
              :limit="1"
              :fileList="fileList"
              accept="application/x-zip-compressed"
              :on-progress="handleProgressTrainingFile"
              :on-error="handleErrorTrainingFile"
              :on-success="uploadedTrainingFile"
              :before-upload="beforeAvatarUploadTrainingFile"
          >
            <el-button slot="trigger" size="small" type="primary">
              选取文件</el-button
            >
          </el-upload>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="导入用户信息"
      :visible.sync="importUserInfoVisible"
      width="500px"
    >
      <div style="color:red;margin-bottom: 20px">
        一次最多只能上传5000条数据
      </div>
      <el-upload
        ref="fileUploader"
        class="avatar-uploader"
        :action="importUserInfoUrl"
        :headers="headers"
        :multiple="false"
        :limit="1"
        :fileList="fileListUser"
        accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :on-progress="handleProgressUser"
        :on-error="handleErrorUser"
        :on-success="uploadedUser"
        :before-upload="beforeAvatarUploadUser"
      >
        <el-button type="text" @click="downloadTemplate">
          下载导入模板</el-button
        >
        <el-button slot="trigger" size="small" type="primary">
          选取文件</el-button
        >
      </el-upload>
    </el-dialog>
    <el-dialog title="添加用户" :visible.sync="addUserVisible" width="40%">
      <el-card>
        <div slot="header" class="clearfix">
          <span>基本信息</span>
        </div>
        <el-form
          :model="userInfo"
          :rules="userRules"
          label-position="right"
          label-width="100px"
          size="small"
          ref="userInfo"
        >
          <el-form-item label="姓名:" prop="realName">
            <el-input
              v-model="userInfo.realName"
              placeholder="姓名"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="mphone">
            <el-input
              v-model="userInfo.mphone"
              placeholder="手机号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="证件号码:" prop="idNumber">
            <el-input
              v-model="userInfo.idNumber"
              placeholder="证件号码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="证件照" prop="idPhoto">
            <image-uploader
              ref="imageUploader"
              :upload-callback="submitUserInfo"
              :file-name="userInfo.idNumber"
              v-model="userInfo.idPhoto"
              upload-path="id-photo-pending"
              :width="100"
              :height="140"
            ></image-uploader>
          </el-form-item>
          <el-form-item align="center">
            <el-button @click="onSubmitUserInfo">保存</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-dialog>
    <el-dialog
      title="关联考场"
      :visible.sync="bindUserExamVisible"
      destroy-on-close
      @close="bindExamIds = []"
      width="30%"
    >
      <el-form label-width="80px">
        <el-form-item label="测评考场">
          <el-select v-model="bindExamIds" multiple placeholder="请选择考场">
            <el-option
              v-for="item in bindExamList"
              :key="item.id"
              :label="item.examName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form>
        <el-form-item>
          <el-button
            type="primary"
            :disabled="!bindExamIds || bindExamIds.length <= 0"
            @click="bindExam"
          >
            确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
        title="添加标签"
        :visible.sync="addTagsVisible"
        destroy-on-close
        @close="bindExamIds = []"
        width="30%"
    >
      <el-form :model="addTagsForm" label-width="80px">
        <el-form-item label="标签" :rules="{ required: true, message: '请输入标签', trigger: 'blur'}">
          <el-input v-model="addTagsForm.tag" maxlength="20" placeholder="请输入标签"></el-input>
        </el-form-item>
      </el-form>
      <el-form>
        <el-form-item>
          <el-button
              type="primary"
              :disabled="!addTagsForm.tag"
              @click="addTags"
          >
            确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="resumeVisiable" width="1200px">
      <resume :userId="userId"></resume>
    </el-dialog>
    <el-dialog
      title="用户信息重复，是否覆盖？"
      :visible.sync="dialogTableVisible"
      width="650px"
      :close-on-click-modal="false"
      style="overflow: hidden"
    >
      <div style="overflow: auto;height: 550px">
        <el-table :data="gridData">
          <el-table-column
              property="realName"
              label="姓名"
              width="150"
              align="center"
          ></el-table-column>
          <el-table-column
              property="idNumber"
              label="证件号码"
              width="200"
              align="center"
          ></el-table-column>
          <el-table-column
              property="mphone"
              label="手机号"
              width="200"
              align="center"
          ></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelExistUser">取消覆盖</el-button>
        <el-button type="primary" @click="doUploadExistUser">确认覆盖</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="用户绑定考场详情"
      :visible.sync="viewProjectVisible"
      width="800px"
    >
      <el-table :data="userProjectList">
        <el-table-column
          label="考场名称"
          prop="examName"
          align="center"
        ></el-table-column>
        <el-table-column
          label="机构"
          prop="agentName"
          align="center"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserPager,
  findUser,
  addUser,
  exportIdPhotoError,
  exportUserList,
  exportUserInfoError,
  doUploadUser,
  doUploadUserSpecial,
  getAgentChildAll,
  viewExam,
  updateUser,
  batchAddTags, getTagsLike, exportTrainingFileError
} from "@/api/userInfo";
import {bindExam} from "@/api/exam"
// import { projectList } from "@/api/projectInfo";
import { getExamList } from "@/api/importUserAccount";
import permission from "@/directive/permission"; // 权限判断指令
import { defaultPageConfig } from "@/config/pagination";
import { getToken, getAgentUserId, getAgentId, getUserImportType } from "@/utils/auth";
import { apiConfig } from "@/config/api";
import ImageUploader from "@/components/imageUploader";
import resume from "@/views/resume/index";
import { getAgentTree } from "@/api/agentInfo";
import selectTree from "@/components/selectTree";
import axios from "axios";
import { findByGroupCode } from "@/api/meta";
export default {
  name: "UserInfo",
  directives: { permission },
  components: {
    ImageUploader,
    resume,
    selectTree
  },
  data() {
    return {
      getUserImportType: getUserImportType(),
      apiConfig: apiConfig,
      fileList: [],
      fileListUser: [],
      searchForm: {
        realName: null,
        idNumber: null,
        agentIds: [],
        baseInfoAuditStatus: null,
        startDate: null,
        endDate: null,
        tags: null,
        bindStatus: null
      },
      dialogTableVisible: false,
      gridData: [],
      exportUserInfoForm: {
        userIds: []
      },
      headers: {
        Authorization: getToken(),
        Authorizator: getAgentUserId(),
        Organization: getAgentId()
      },
      registerDate: [],
      userInfo: {
        realName: null,
        idNumber: null,
        mphone: null,
        registerFrom: 2,//机构
        idPhoto: null
      },
      userFromOptions: [
        { label: "自行注册", value: 1 },
        { label: "机构", value: 2 }
      ],
      auditStatusOptions: [
        { label: "已通过", value: 1 },
        { label: "未通过", value: 2 },
        { label: "未审核", value: 3 }
      ],
      tableData: [],
      currentPage: 1,
      tableTotal: -1,
      tablePages: 0,
      loading: false,
      tableLayout: defaultPageConfig.layout,
      pageSize: defaultPageConfig.pageSize,
      importPhotoVisible: false,
      importTrainingFileVisible: false,
      importUserInfoVisible: false,
      userInfoVisible: false,
      isUserEdit: false,
      loadingAgent: false,
      addUserVisible: false,
      bindUserExamVisible: false,
      addTagsVisible: false,
      loadingTagsAgent: false,
      loadingTagsLike: false,
      bindForm: {
        userIds: []
      },
      addTagsForm: {
        tag: '',
      },
      tagsLikeList: [],
      bindExamIds: [],
      bindExamList: [],
      userRules: {
        realName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        mphone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[0-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur,change"
          }
        ],
        idNumber: [
          { required: true, message: "请输入证件号码", trigger: "blur" },
          { min: 7, message: "最少7个字符", trigger: "blur" }
        ]
      },
      agentList: [],
      resumeVisiable: false,
      userId: null,
      viewProjectVisible: false,
      userProjectList: [],
      bindExamStatus: [
        { label: "未绑定", value: 0 },
        { label: "已绑定", value: 1 }
      ],
      agentId: null,
      agentTreeData: [],
      resumeFlag: false,
      tableHeight: 600
    };
  },
  watch: {
    registerDate(val) {
      if (val && val.length > 0) {
        this.searchForm.startDate = val[0] + " 00:00:00";
        this.searchForm.endDate = val[1] + " 23:59:59";
      } else {
        this.searchForm.startDate = null;
        this.searchForm.endDate = null;
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.isFormEdit) {
        return "更新用户";
      } else {
        return "新增用户";
      }
    },
    importUserInfoUrl() {
      if (getUserImportType() === 'special') {
        return this.apiConfig.userInfo.api.importUserInfo.url.importSpecial
      }
      return this.apiConfig.userInfo.api.importUserInfo.url.import
    }
  },
  created() {
    let now = new Date();
    let startDate = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate());
    this.registerDate = [this.$dayjs(startDate).format('YYYY-MM-DD'), this.$dayjs(now).format('YYYY-MM-DD')]
    this.searchForm.startDate = this.registerDate[0] + " 00:00:00";
    this.searchForm.endDate = this.registerDate[1] + " 23:59:59";
    this.getBindExams();
    this.getAgentChildAll();
    this.getAgentTree();
    this.findByGroupCode();
  },
  mounted() {
    let that = this;
    that.$nextTick(() => {
      that.tableHeight =
        document.getElementsByClassName("card-fix-height")[0].clientHeight - 40;
    });
  },
  methods: {
    findByGroupCode() {
      findByGroupCode("resumeFag").then(res => {
        if (res.code == 200 && res.data && res.data.length > 0) {
          if (res.data[0].metaCode && res.data[0].metaCode == "1") {
            this.resumeFlag = true;
          }
        }
      });
    },
    // eslint-disable-next-line no-unused-vars
    setTreeMenu(key, data) {
      if (!key) {
        this.searchForm.agentIds = [];
      } else {
        this.searchForm.agentIds = key;
      }
    },
    handleSizeChange() {
      this.getUserPager();
    },
    onGetTagsLike(query) {
      let that = this;
      if (query) {
        that.loadingTagsLike = true;
        getTagsLike({
          tag: query
        })
            .then(res => {
              if (res && res.code === 200) {
                that.tagsLikeList = res.data;
              }
            })
            .finally(() => {
              that.loadingTagsLike = false;
            });
      }
    },
    handleSelectionChange: function(val) {
      this.exportUserInfoForm.userIds = val.map(item => {
        return item.userId;
      });
      this.bindForm.userIds = val.map(item => {
        return item.userId;
      });
    },
    jumpPage(router) {
      this.$router.push(router);
    },
    showUserResume(row) {
      this.userId = row.userId;
      this.resumeVisiable = true;
    },
    // 格式化审核状态
    statusFormatter(row) {
      if (row.baseInfoAuditStatus === 1) {
        return "无申请";
      } else if (row.baseInfoAuditStatus === 2) {
        return "待审核";
      } else if (row.baseInfoAuditStatus === 3) {
        return "已通过";
      } else {
        return "已拒绝";
      }
    },
    // 时间格式化
    dateFormatter(row, column, cellValue) {
      if (cellValue) {
        let date = new Date(cellValue);
        let year = date.getFullYear();
        let month =
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1;
        let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        let hours =
          date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        let minutes =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        let seconds =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
      return "暂无";
    },
    formatterAgent(row, column, cellValue) {
      for (let i = 0; i < this.agentList.length; i++) {
        if (cellValue === this.agentList[i].agentId) {
          return this.agentList[i].agentName;
        }
      }
    },
    onSubmitUserInfo() {
      if (
        this.userInfo.idPhoto &&
        this.userInfo.idPhoto.indexOf("data:") !== -1
      ) {
        this.$refs["imageUploader"].submit();
      } else {
        this.$refs["userInfo"].validate(valid => {
          if (valid) {
            this.loadingInstance = this.$loading(false);
            this.submitUserInfo();
            this.loadingInstance.close();
          } else {
            return false;
          }
        });
      }
    },
    submitUserInfo() {
      let that = this;
      that.loadingInstance = that.$loading(false);
      addUser(that.userInfo).then(res => {
        that.loadingInstance.close();
        if (res && res.code === 200) {
          that.$message.success("保存成功");
          that.addUserVisible = false;
          that.onSearchUser();
          if (that.resumeFlag) {
            let users = [];
            users.push(that.userInfo);
            that.importZtt(users);
          }
        }
      });
    },
    // 查询用户列表
    onSearchUser() {
      this.currentPage = 1;
      this.getUserPager();
    },
    // 用户分页查询
    getUserPager() {
      let that = this;
      that.loading = true;
      let form = this._.cloneDeep(this.searchForm);
      form.page = that.currentPage;
      form.pageSize = that.pageSize;
      getUserPager(form)
        .then(res => {
          if (res && res.code === 200) {
            if (res.data) {
              if (res.data.list) {
                that.tableData = res.data.list.map(v => {
                  if (v.tags) {
                    v.tags = [...new Set(v.tags.split(','))].join(',')
                  }
                  return v;
                });
              }
            } else {
              that.tableData = [];
            }
            if (that.tableData.length < 1) {
              that.tablePages = 0;
              that.tableTotal = 0;
            } else {
              that.tablePages = Number(res.data.pages);
              that.tableTotal = Number(res.data.total);
            }
          } else {
            that.tableData = [];
            that.tablePages = 0;
            that.tableTotal = 0;
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    // 导入证件照

    // 导出个人信息
    exportUserInfo() {
      if (
        !this.exportUserInfoForm.userIds ||
        this.exportUserInfoForm.userIds.length <= 0
      ) {
        this.$confirm(
          "您未勾选任何数据，系统将根据搜索条件进行下载, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          this.exportUserInfoCall(true);
        });
      } else {
        this.exportUserInfoCall(false);
      }
    },
    exportUserInfoCall(flag) {
      const loading = this.$loading({
        lock: true,
        text: "正在下载",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let searchForm = this._.cloneDeep(this.searchForm);
      let exportUserInfoForm = this._.cloneDeep(this.exportUserInfoForm);
      if (flag) {
        this._.assign(exportUserInfoForm, searchForm);
      }
      exportUserList(exportUserInfoForm)
        .then(res => {
          if (!res) {
            this.$message.error("下载文件失败");
            return false;
          }
          if (res.type && res.type.includes('application/json')) {
            let that = this;
            const reader = new FileReader();
            reader.onload = function (event) {
              const message = JSON.parse(reader.result).message;
              that.$message.error(message);
            }
            reader.readAsText(res);
            return
          }
          const blob = new Blob([res.data], {
            type: "application/octet-stream"
          });
          const downloadElement = document.createElement("a");
          const href = window.URL.createObjectURL(blob);
          let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
          let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
          let result = patt.exec(contentDisposition);
          let filename = decodeURI(result[1]);
          downloadElement.style.display = "none";
          downloadElement.href = href;
          downloadElement.download = filename; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .finally(function() {
          loading.close();
        });
    },
    // 查询用户来源(机构列表)

    // 审核

    // 查看个人信息
    showUserInfo(row) {
      this.isUserEdit = false;
      this.userInfoVisible = true;
      this.onFindUserInfo(row.userId);
    },
    // 编辑个人信息
    /*editUserInfo(id) {
      this.isUserEdit = true;
      this.userInfoVisible = true;
    },*/
    // 查询用户信息
    onFindUserInfo(id) {
      findUser(id).then(res => {
        if (res && res.code === 200) {
          this.userInfo = res.data;
        }
      });
    },
    // 保存个人信息
    // 取消保存
    cancle() {},
    // 新增用户
    onCreateUser() {
      this.addUserVisible = true;
    },
    // 翻页
    onCurrentPageChange(page) {
      this.currentPage = page;
      this.getUserPager();
    },
    beforeAvatarUpload(file) {
      let isZip = (file.type === "application/x-zip-compressed"||file.type === "application/zip");
      if (!isZip) {
        this.$message.error("只能上传zip格式压缩包!");
      }
      return isZip;
    },
    beforeAvatarUploadTrainingFile(file) {
      let isZip = (file.type === "application/x-zip-compressed"||file.type === "application/zip");
      if (!isZip) {
        this.$message.error("只能上传zip格式压缩包!");
      }
      return isZip;
    },
    beforeAvatarUploadUser(file) {
      let isExcel;
      if (!file.type) {
        var suffixName = file.name.substring(file.name.lastIndexOf(".") + 1);
        if (suffixName === "xlsx" || suffixName === "xls") {
          isExcel = true;
        } else {
          isExcel = false;
        }
      } else {
        isExcel =
          file.type === "application/vnd.ms-excel" ||
          file.type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      }
      let isLt500K = file.size / 1024 < 500;

      if (!isExcel) {
        this.$message.error("只能上传excel文件!");
      }
      if (!isLt500K) {
        this.$message.error("上传excel大小不能超过 500KB!");
      }
      return isExcel && isLt500K;
    },
    handleProgress: function() {
      this.loadingInstance = this.$loading({ lock: true, text: "正在上传..." });
    },
    handleProgressTrainingFile: function() {
      this.loadingInstance = this.$loading({ lock: true, text: "正在上传..." });
    },
    handleProgressUser: function() {
      this.loadingInstance = this.$loading({ lock: true, text: "正在上传..." });
    },
    handleError: function(error) {
      this.$message({
        message: error,
        type: "error"
      });
      this.loadingInstance.close();
    },
    handleErrorTrainingFile: function(error) {
      this.$message({
        message: error,
        type: "error"
      });
      this.loadingInstance.close();
    },
    handleErrorUser: function(error) {
      this.$message({
        message: error,
        type: "error"
      });
      this.loadingInstance.close();
    },
    uploaded: function(response) {
      if (response.code !== 200) {
        this.$confirm(response.message, "提示", {
          type: "error"
        });
        if (response.code === 9998) {
          exportIdPhotoError().then(res => {
            if (!res) {
              this.$message.error("下载文件失败");
              return false;
            }
            const blob = new Blob([res.data], {
              type: "application/octet-stream"
            });
            const downloadElement = document.createElement("a");
            const href = window.URL.createObjectURL(blob);
            let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
            let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
            let result = patt.exec(contentDisposition);
            let filename = decodeURI(result[1]);
            downloadElement.style.display = "none";
            downloadElement.href = href;
            downloadElement.download = filename; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
          });
        }
      } else {
        this.$message({
          message: "导入成功",
          type: "success"
        });
      }
      this.fileList = [];
      this.loadingInstance.close();
      this.importPhotoVisible = false;
    },
    uploadedTrainingFile: function(response) {
      if (response.code !== 200) {
        this.$confirm(response.message, "提示", {
          type: "error"
        });
        if (response.code === 9998) {
          exportTrainingFileError().then(res => {
            if (!res) {
              this.$message.error("下载文件失败");
              return false;
            }
            const blob = new Blob([res.data], {
              type: "application/octet-stream"
            });
            const downloadElement = document.createElement("a");
            const href = window.URL.createObjectURL(blob);
            let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
            let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
            let result = patt.exec(contentDisposition);
            let filename = decodeURI(result[1]);
            downloadElement.style.display = "none";
            downloadElement.href = href;
            downloadElement.download = filename; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
          });
        }
      } else {
        this.$message({
          message: "导入成功",
          type: "success"
        });
      }
      this.fileList = [];
      this.loadingInstance.close();
      this.importTrainingFileVisible = false;
    },
    uploadedUser: function(response, file) {
      if (response.code !== 200) {
        this.$confirm(response.message, "提示", {
          type: "error"
        });
        if (response.code === 9998) {
          exportUserInfoError().then(res => {
            if (!res) {
              this.$message.error("下载文件失败");
              return false;
            }
            const blob = new Blob([res.data], {
              type: "application/octet-stream"
            });
            const downloadElement = document.createElement("a");
            const href = window.URL.createObjectURL(blob);
            let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
            let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
            let result = patt.exec(contentDisposition);
            let filename = decodeURI(result[1]);
            downloadElement.style.display = "none";
            downloadElement.href = href;
            downloadElement.download = filename; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
          });
        }
      } else {
        //返回重复用户信息
        if (response.data && response.data.length > 0) {
          this.file = file;
          this.gridData = response.data;
          this.dialogTableVisible = true;
        } else {
          this.doUploadExistUser();
        }
      }
      this.fileListUser = [];
      this.loadingInstance.close();
      this.importUserInfoVisible = false;
    },
    downloadTemplate() {
      if (getUserImportType() === 'special') {
        window.open("/template/导入用户信息模板-1.xlsx");
      } else {
        window.open("/template/导入用户信息模板.xlsx");
      }
    },
    getBindExams() {
      getExamList().then(res => {
        if (res.code === 200) {
          this.bindExamList = res.data;
        }
      });
    },
    bindExam() {
      bindExam({
        userIds: this.bindForm.userIds,
        examIds: this.bindExamIds
      }).then(
          res => {
            if (res.code === 200) {
              this.$message({
                message: "绑定成功",
                type: "success"
              });
              this.bindUserExamVisible = false;
            }
          }
      );
    },
    addTags(){
      batchAddTags({
        tag: this.addTagsForm.tag,
      }, this.bindForm.userIds).then(res=>{
        if (res.code === 200) {
          this.getUserPager();
          this.$message({
            message: "添加成功",
            type: "success"
          });
        }
        this.addTagsVisible = false;
      })
    },
    doUploadExistUser() {
      this.doUploadUser(1);
      this.dialogTableVisible = false;
    },
    cancelExistUser() {
      this.doUploadUser(0);
      this.dialogTableVisible = false;
    },
    async doUploadUser(flag) {
      let res;
      let loadingInstance = this.$loading({lock: true, text: '正在导入数据...'})
      if (getUserImportType() === 'special') {
        res = await doUploadUserSpecial(flag);
      } else {
        res = await doUploadUser(flag);
      }
      loadingInstance.close()
      if (res && res.code === 200) {
        if (res.data && res.data.length > 0 && this.resumeFlag) {
          let users = res.data;
          this.importZtt(users);
        }
        this.getUserPager();
        this.$message({
          message: "用户信息导入成功",
          type: "success"
        });
      }
    },
    importZtt(users) {
      if (!users || users.length < 1) {
        return false;
      }
      let ztt = {
        url: "zczk-agent",
        users: users
      };
      axios({
        // url: "http://localhost:8080/h/importZczkUser",
        //已废弃接口
        url: "http://m.cvaetest.com/h/importZczkUser",
        method: "post",
        data: ztt
      })
        .then(function(response) {
          console.log(response);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getAgentChildAll() {
      getAgentChildAll().then(res => {
        if (res.code === 200 && res.data) {
          this.agentList = res.data;
          this.searchForm.agentIds.push(this.agentList[0].agentId);
          this.agentId = this.agentList[0].agentId;
          this.getUserPager();
        }
      });
    },
    viewExam(row) {
      viewExam(row.userId).then(res => {
        if (res.code === 200) {
          if (res.data) {
            this.userProjectList = res.data;
            this.viewProjectVisible = true;
          }
        }
      });
    },
    delUser(row) {
      let that = this;
      that
        .$confirm("删除的用户数据无法恢复,是否继续操作？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          updateUser(row.userId, {}).then(res => {
            if (res && res.code === 200) {
              that.$message.success("删除成功");
              that.getUserPager();
            }
          });
        })
        .catch(() => {});
    },
    getAgentTree() {
      let that = this;
      getAgentTree(this.searchForm, {}).then(res => {
        if (res && res.code === 200) {
          that.agentTreeData = res.data;
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.main-user {
  .dashboard {
    &-container {
      margin: 30px;
    }
    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }
  /deep/ .el-card__body {
    overflow: hidden !important;
    .el-table--enable-row-transition {
      overflow: hidden !important;
    }
  }
  ::-webkit-scrollbar {
    background-color: #f8f8ff;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #dedfe9;
  }
  .card-fix-height {
    position: relative;
    height: calc(100vh - 50px - 35px - 15px - 102px - 52px - 72px);
  }
  .button {
    padding-bottom: 20px;
  }
  /deep/ .search-form .el-form-item#myselfAgent .el-form-item__content {
    .el-select {
      width: 240px;
      .el-select__tags-text {
        display: inline-block;
        max-width: 115px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .el-tag__close.el-icon-close {
        top: -6px;
      }
    }
  }
}
</style>
